import * as RadixSwitch from "@radix-ui/react-switch";
import React from "react";
import clsx from "clsx";

export const Switch = ({ checked = false, onCheckedChange, disabled = false }) => {
  return (
    <RadixSwitch.Root
      className={clsx(
        "w-11 h-6 bg-darkGray rounded-full border relative transition-colors duration-200",
        {
          "bg-primary border-primary": checked,
          "opacity-50 cursor-not-allowed bg-darkGray": disabled,
        }
      )}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
    >
      <RadixSwitch.Thumb
        className={clsx(
          "block w-5 h-5 bg-white border rounded-full shadow transition-transform duration-200 transform translate-x-0",
          {
            "translate-x-5 bg-darkGray": checked,
          }
        )}
      />
    </RadixSwitch.Root>
  );
};
